/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Box, Card, CardContent, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Tarjeta_Caracteristicas_Home = ({icono, titulo, descripcion}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: -70,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    p: 2
                }}
            >
                <img src={icono} alt="Icono" width={80}/>
            </Box>
            <Card
                sx={{
                    backgroundColor: 'white',
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    borderRadius: 4,
                    minHeight: 220,
                    boxShadow: 4
                }}>
                <CardContent
                    sx={{display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center",}}>
                    <Typography
                                sx={{
                                    marginTop: 4,
                                    mx: 7,
                                    color: theme.palette.primary.main,
                                    fontSize: 24,
                                    fontWeight: 800,
                                    lineHeight: 1.2
                                }}>
                        {titulo}
                    </Typography>
                    <Typography variant="body2" component="p" sx={{marginTop: 1, marginX: sCell ? 2 :  8, fontSize: 16}}>
                        {descripcion}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    )

}
export default Tarjeta_Caracteristicas_Home